import { Outlet } from "react-router-dom";

export default function Layout() {
    return(
        <div className="body custom-bg-colour3">
            <Outlet />
        </div>
    );
}